export default "__VITE_ASSET__7b51e794__"